import { type ButtonHTMLAttributes, forwardRef, type ReactNode } from "react";

import { Button, type ButtonProps, Icon_TriangleDown } from "@shapr3d/frontend-lib";
import classNames from "classnames";

import style from "./SelectActivator.module.css";

export const SelectActivator = forwardRef<
  HTMLButtonElement,
  {
    icon?: ReactNode;
    label: string;
    variant?: ButtonProps["variant"];
  } & ButtonHTMLAttributes<HTMLButtonElement>
>(({ icon, label, variant = "borderless", ...attrs }, ref) => {
  return (
    <Button
      ref={ref}
      variant={variant}
      className={classNames(style.button, attrs.className)}
      type="button"
      {...attrs}
    >
      <div className={style.borderlessSelectActivator}>
        {icon}
        <span>{label}</span>
        <Icon_TriangleDown className={style.icon} />
      </div>
    </Button>
  );
});
